module.exports = "/_next/static/images/recommendations_desktop-373e03088db6b82388e8db1f60e590d9.jpg";